import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Input, Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import useDropdownStyles from './useDropdownStyles';

const useChipStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
        '&:label': {
            color: theme.palette.primary.main,
        },
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const getLabel = (id, fields) => {
    for (let i = 0; i < fields.length; i++) {
        if (fields[i].id === id) {
            return fields[i].name;
        }
    }
};

export default function DropDown(props) {
    const { selected } = props;
    const classes = useDropdownStyles();
    const chipClasses = useChipStyles();
    return (
        <FormControl className={classes.root}>
            <InputLabel htmlFor="outlined-age-native-simple">{props.title}</InputLabel>
            <Select
                className={classes.select}
                disabled={props.disabled}
                labelId="label-id"
                id="multi-select"
                multiple
                value={selected}
                onChange={(e) => props.onChange(e)}
                input={<Input />}
                renderValue={(selected) => (
                    <div className={chipClasses.chips}>
                        {selected.map((value) => (
                            <Chip key={value} label={getLabel(value, props.fields)} className={chipClasses.chip} />
                        ))}
                    </div>
                )}
                MenuProps={MenuProps}
                style={{ width: '100%' }}
            >
                {props.fields.map((field) => (
                    <MenuItem key={field.id} value={field.id} disabled={props.disabled}>
                        {field.name}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText variant="subtitle2">{props.helperText}</FormHelperText>
        </FormControl>
    );
}
